import * as React from 'react';

import { ModelProvider } from '@rematter/frontend-lib-api-client';
import {
  Button,
  DateRangePicker,
  SearchField,
  Select,
  Spacer,
} from '@rematter/ui-web';
import { useAtom } from 'jotai';

import * as state from '../../_state/usageList.state';
import { useTranslations } from '../../i18n/useTranslations';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const UsageFilterBar = () => {
  const t = useTranslations();
  const [modelFilter, setModelFilter] = useDebouncedAtom(
    state.$modelFilter,
    300,
  );
  const [modelProviderFilter, setModelProviderFilter] = useAtom(
    state.$modelProviderFilter,
  );
  const [dateRange, setDateRange] = useAtom(state.$dateRange);

  const hasFilters = modelFilter || modelProviderFilter || dateRange;

  const clearFilters = () => {
    setModelFilter('');
    setModelProviderFilter(undefined);
    setDateRange(null);
  };

  return (
    <div className="@UsageFilterBar flex w-full items-center gap-4 p-4">
      <DateRangePicker
        value={dateRange}
        onChange={setDateRange}
        aria-label={t.aiManagement.usage.filters.dateRange}
        className="min-w-[200px]"
      />

      <Select<ModelProvider | 'all'>
        aria-label={t.aiManagement.usage.filters.modelProvider}
        placeholder={t.aiManagement.usage.filters.modelProvider}
        className="w-[150px]"
        value={(modelProviderFilter as ModelProvider) ?? 'all'}
        onChange={(key) =>
          setModelProviderFilter(key === 'all' ? undefined : key)
        }
        options={[
          { key: 'all', label: t.aiManagement.usage.filters.allProviders },
          {
            key: 'Gemini',
            label: t.aiManagement.agents.details.fields.provider.options.gemini,
          },
          {
            key: 'OpenAI',
            label: t.aiManagement.agents.details.fields.provider.options.openai,
          },
          {
            key: 'Anthropic',
            label:
              t.aiManagement.agents.details.fields.provider.options.anthropic,
          },
          {
            key: 'Cerebras',
            label:
              t.aiManagement.agents.details.fields.provider.options.cerebras,
          },
        ]}
      />

      <SearchField
        autoFocus
        aria-label={t.aiManagement.usage.filters.model}
        placeholder={t.aiManagement.usage.filters.model}
        className="w-[200px]"
        value={modelFilter ?? ''}
        onChange={(value) => setModelFilter(value)}
      />

      {hasFilters && (
        <Button onPress={clearFilters} variant="ghost" size="small">
          {t.aiManagement.usage.filters.clearFilters}
        </Button>
      )}

      <Spacer />
    </div>
  );
};
